export enum FormioComponentType {
  'default' = 'components',
  'columns' = 'columns',
  'container' = 'components',
  'fieldSet' = 'components',
  'panel' = 'components',
  'selectboxes' = 'values',
  'survey' = 'questions',
  'tabs' = 'components',
  'table' = 'rows',
  'well' = 'components',
}

export enum KeyRefType {
  'DEFAULT' = 'DEFAULT',
  'KEY' = 'KEY',
  'TYPE' = 'TYPE',
  'VALUE' = 'VALUE',
}

export enum FormioComponentKeyRef {
  'default' = 'DEFAULT',
  'columns' = 'DEFAULT',
  'container' = 'KEY',
  'fieldSet' = 'DEFAULT',
  'panel' = 'DEFAULT',
  'selectboxes' = 'VALUE',
  'survey' = 'VALUE',
  'tabs' = 'DEFAULT',
  'table' = 'DEFAULT',
  'well' = 'DEFAULT',
}
